// extracted by mini-css-extract-plugin
module.exports = {"phoneWrap":"index_phoneWrap-15FIF","screen":"index_screen-1csm6"};